var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-end"},[_c('div',{staticClass:"navbar-item"},[_c('p',{staticStyle:{"padding-right":"17px"}},[_vm._v("Logged in as "+_vm._s(this.getUsername))]),_c('div',{staticClass:"buttons"},[_c('b-button',{attrs:{"type":"is-light"},on:{"click":_vm.logout}},[_vm._v("Log out")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }